import { render, staticRenderFns } from "./aboutAudience.vue?vue&type=template&id=21f05e1e&scoped=true"
import script from "./aboutAudience.vue?vue&type=script&lang=js"
export * from "./aboutAudience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f05e1e",
  null
  
)

export default component.exports